<template>
  <div v-if="visible" class="qilin-modal" role="dialog" aria-modal="true" aria-labelledby="qilin-profile-title" @click.self="close">
    <form class="qilin-modal__card" novalidate @submit.prevent="save">
      <button v-if="pet.name && pet.gender" class="qilin-modal__close" type="button" aria-label="ปิด" @click="close">×</button>
      <span class="qilin-modal__eyebrow">คู่หูของคุณ</span>
      <h2 id="qilin-profile-title">{{ pet.name ? 'แก้ไขชื่อกิเลน' : 'ทำความรู้จักกันก่อน' }}</h2>
      <p>เลือกเพศได้ครั้งเดียว ส่วนการตั้งชื่อครั้งแรกฟรี</p>

      <label>ชื่อกิเลน</label>
      <input v-model.trim="name" maxlength="20" required placeholder="เช่น น้องโชคดี">

      <label>เพศ</label>
      <div class="qilin-modal__genders">
        <button type="button" :disabled="Boolean(pet.gender)" :class="{ active: gender === 'male' }" @click="gender = 'male'">♂ กิเลนตัวผู้</button>
        <button type="button" :disabled="Boolean(pet.gender)" :class="{ active: gender === 'female' }" @click="gender = 'female'">♀ กิเลนตัวเมีย</button>
      </div>
      <small v-if="pet.gender">เพศถูกบันทึกแล้วและไม่สามารถเปลี่ยนได้</small>
      <div v-if="isRename" class="qilin-modal__cost">การเปลี่ยนชื่อครั้งนี้ใช้ 5 เหรียญ</div>
      <div v-if="displayError" class="qilin-modal__error" role="alert">{{ displayError }}</div>
      <button class="qilin-modal__save" type="submit" :disabled="saving">
        {{ saving ? 'กำลังบันทึก...' : isRename ? 'ยืนยันเปลี่ยนชื่อ' : 'เริ่มเลี้ยงกิเลน' }}
      </button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'QilinProfileModal',
  props: {
    visible: { type: Boolean, default: false },
    pet: { type: Object, required: true },
    saving: { type: Boolean, default: false },
    error: { type: String, default: '' }
  },
  data () { return { name: '', gender: '', validationError: '' } },
  computed: {
    isRename () { return Boolean(this.pet.name && this.name && this.pet.name !== this.name) },
    displayError () { return this.validationError || this.error }
  },
  watch: {
    visible: {
      immediate: true,
      handler (visible) {
        if (visible) {
          this.name = this.pet.name || ''
          this.gender = this.pet.gender || ''
          this.validationError = ''
        }
      }
    },
    name () { this.validationError = '' },
    gender () { this.validationError = '' }
  },
  methods: {
    close () { if (this.pet.name && this.pet.gender && !this.saving) this.$emit('close') },
    save () {
      if (!this.name) {
        this.validationError = 'กรุณาตั้งชื่อให้น้องก่อน'
        return
      }
      if (!this.gender) {
        this.validationError = 'กรุณาเลือกเพศก่อนเริ่มเลี้ยง'
        return
      }
      this.validationError = ''
      this.$emit('save', { name: this.name, gender: this.gender })
    }
  }
}
</script>

<style scoped>
.qilin-modal { position: fixed; z-index: 2400; inset: 0; display: grid; place-items: center; padding: 18px; background: rgba(1, 3, 18, .82); backdrop-filter: blur(8px); font-family: 'Kanit', sans-serif; }
.qilin-modal__card { position: relative; width: min(440px, 100%); padding: 28px; border: 1px solid rgba(255, 218, 112, .35); border-radius: 24px; background: linear-gradient(160deg, #112b5d, #070a2b 72%); box-shadow: 0 28px 80px rgba(0, 0, 0, .52); color: #fff; }
.qilin-modal__close { position: absolute; top: 13px; right: 13px; width: 34px; height: 34px; border: 0; border-radius: 50%; background: rgba(255, 255, 255, .1); color: #fff; font-size: 24px; }
.qilin-modal__eyebrow { color: #6ce1c1; font-size: 12px; font-weight: 900; letter-spacing: .08em; }
h2 { margin: 5px 0 4px; font-size: 25px; }
p { margin: 0 0 19px; color: rgba(255, 255, 255, .64); font-size: 13px; }
label { display: block; margin: 13px 0 7px; font-size: 13px; font-weight: 800; }
input { width: 100%; height: 48px; padding: 0 13px; border: 1px solid rgba(255, 255, 255, .16); border-radius: 13px; outline: none; background: rgba(255, 255, 255, .08); color: #fff; font-family: inherit; }
input:focus { border-color: #64dbbb; box-shadow: 0 0 0 3px rgba(100, 219, 187, .12); }
.qilin-modal__genders { display: grid; grid-template-columns: 1fr 1fr; gap: 9px; }
.qilin-modal__genders button { min-height: 48px; border: 1px solid rgba(255, 255, 255, .14); border-radius: 13px; background: rgba(255, 255, 255, .06); color: rgba(255, 255, 255, .68); font-family: inherit; font-weight: 800; }
.qilin-modal__genders button.active { border-color: #ffd65a; background: rgba(251, 200, 68, .15); color: #ffe689; }
.qilin-modal__genders button:disabled:not(.active) { opacity: .35; }
small { display: block; margin-top: 7px; color: rgba(255, 255, 255, .45); font-size: 11px; }
.qilin-modal__cost { margin-top: 15px; padding: 10px; border-radius: 10px; background: rgba(251, 200, 68, .1); color: #ffe079; font-size: 12px; text-align: center; }
.qilin-modal__error { margin-top: 14px; padding: 10px 12px; border: 1px solid rgba(255, 115, 115, .28); border-radius: 10px; background: rgba(255, 83, 83, .1); color: #ffb6b6; font-size: 12px; text-align: center; }
.qilin-modal__save { width: 100%; min-height: 49px; margin-top: 18px; border: 0; border-radius: 14px; background: linear-gradient(135deg, #ffd85d, #f39a32); color: #181327; font-family: inherit; font-weight: 900; }
.qilin-modal__save:disabled { opacity: .48; }
</style>
